import { useEffect, useRef } from "react";

import { signalWebSocketClient } from "../services/signalWebSocketClient";
import type { DeployLiveMessage } from "../types/strategyDeploy";

/** Live-strategy updates (signals, fills, closes, status) from the dashboard WebSocket. */
export function useStrategyDeployLive(onMessage: (message: DeployLiveMessage) => void): void {
  const ref = useRef(onMessage);
  useEffect(() => {
    ref.current = onMessage;
  }, [onMessage]);
  useEffect(
    () =>
      signalWebSocketClient.subscribeMessages((raw) => {
        const msg = raw as DeployLiveMessage;
        if (msg && msg.type === "strategy_deploy") ref.current(msg);
      }),
    []
  );
}
